/**
 * Configuration keys used to access specific global config flags.
 * @readonly
 * @enum {string}
 */
export const CONFIG_KEYS = {
  /** Enables/disables scrollbar */
  isScrollbarEnabled: "isScrollbarEnabled",
  /** Enables/disables pagination */
  isPaginationEnabled: "isPaginationEnabled",
  /** Enables/disables EA role template feature */
  isEaRoleTemplateEnabled: "isEaRoleTemplateEnabled",
  /** Enables/disables campaign retry feature */
  isCampaignRetryEnabled: "isCampaignRetryEnabled",
  /** Enables/disables SMS dashboard */
  isSMSDashboardEnabled: "isSMSDashboardEnabled",
  /** Enables/disables MCC/MNC feature */
  isMccMncEnabled: "IMSCI_ENABLED", // "isMccMncEnabled",
  /** */
  isQuotaEnabled: "isQuotaEnabled",
  /** Enables/disables Sender Address for Centro  */
  isSenderAddressListingEnable: "isSenderAddressListingEnable",
  /** Enable/disable 2fa */
  mfaEnable: "mfaEnable",
  /** Enable/disable the new Dashboard screen*/
  newDashboardEnabled: "newDashboardEnabled",
};
